export default __webpack_public_path__ + "static/media/Bylogo.048ba2b0.png";